@switch (clockType()) {
  @case ("analog") {
    <app-analog-clock></app-analog-clock>
  }
  @case ("digital") {
    <div class="digital-clock" [style.color]="digitalClockColor()">
      {{ digitalClockTime() }}
    </div>
  }
}
